import React, { useContext, useState } from 'react'
import { Card, CardHeader, Avatar, Typography, Box, Grid } from '@mui/material'
import { InputButton, InputText } from '../../../Simple'
import { notConfig, notAgend, semFoto } from '../../../../assets'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'
import { LuClipboardPenLine } from 'react-icons/lu'
import { IoChatbubbles, IoChevronBackOutline } from 'react-icons/io5'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { ChatContext } from '../../../../contexts/ChatContext'
import { AuthContext } from '../../../../contexts/AuthContext'
import RouterHook from '../../../../contexts/RouterHook'
import BlockIcon from '@mui/icons-material/Block'
import { UsuarioContext } from '../../../../contexts/UsuarioContext'
import { LocalStorage } from '../../../../services'

export default function NoAccess() {
  const serverRouter = RouterHook()
  const { sttAuthCtx } = useContext(AuthContext)
  const { userUCtx } = useContext(UsuarioContext)
  const { sttPg, actionsCtxEmps } = useContext(EmpresasContext)
  const { actionsChatCtx, sttChatCtx } = useContext(ChatContext)
  const emp = sttPg.empresa

  const [solAcesso, setSolAcesso] = useState('')
  const [imgUrl, setImgUrl] = useState('' + emp.urlFoto + emp.foto)

  function GoChat() {
    if (sttChatCtx.modeChat !== 'diretos') actionsChatCtx.handleModeChat('diretos')
    LocalStorage.set('chat-selected', { mode: 'diretos', id: emp.idempresa })
    serverRouter('chat', userUCtx.usuario.idusuario)
  }

  return (
    <Grid container rowGap={3} sx={{ padding: '0px 14px', maxWidth: '1200px', height: '100%' }}>
      <Grid item xs={12}>
        <Card
          style={{
            margin: '0 auto',
            border: '1px solid #ccc',
            width: '100%',
          }}
        >
          <CardHeader
            avatar={
              <IoChevronBackOutline
                className='icon-back-pg'
                onClick={() => {
                  serverRouter('back')
                }}
              />
            }
            title={
              <Box display='flex' alignItems='center'>
                <Avatar
                  sx={{ width: 140, height: 100 }}
                  alt={emp.nome}
                  variant='rounded'
                  src={imgUrl}
                  onError={() => setImgUrl(semFoto)}
                  style={{ marginRight: 10 }}
                />
                <Box>
                  <Typography variant='h6'>{emp.nome}</Typography>
                </Box>
              </Box>
            }
          />
        </Card>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          marginBottom: `${sttPg.selectedHorarios.length > 0 ? '100px' : 0}`,
          height: 'calc(100% - 180px)',
        }}
      >
        <Card
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          {sttPg.modePg === 'config' ? (
            <Box
              sx={{ mt: 1, p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
              <img
                src={notConfig}
                alt='Centro esportivo não configurado'
                style={{ width: '100px', height: 'auto' }}
              />
              <Typography variant='h6' fontWeight='bold' color='textSecondary'>
                Em configuração
              </Typography>
              <Typography variant='body1' align='center' color='gray' sx={{ mt: 1 }}>
                {emp.nome} está sendo preparada e em breve estará disponível para receber
                agendamentos
              </Typography>
              <Typography variant='body1' align='center' color='gray'>
                Você pode mandar uma mensagem direta para o centro esportivo manifestando seu
                interesse em agendar
              </Typography>
              <InputButton
                fullWidth={false}
                variant='contained'
                sx={{ padding: '5px 30px', marginTop: '10px' }}
                startIcon={<IoChatbubbles size={25} />}
                onClick={() => {
                  GoChat()
                }}
              >
                Mensagem Direta
              </InputButton>
            </Box>
          ) : !sttAuthCtx.isLogged ? (
            <Box
              sx={{ mt: 1, p: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
              <LockOutlinedIcon color='primary' sx={{ fontSize: 50, mb: 1 }} />
              <Typography variant='h6' fontWeight='bold' sx={{ mb: 1 }}>
                Entre com sua conta
              </Typography>

              <Typography variant='body2' align='center'>
                Você precisa acessar sua conta para poder agendar neste centro esportivo.
              </Typography>
              <Box sx={{ width: '20dvw', mt: 3 }}>
                <InputButton onClick={() => serverRouter('login')} sx={{ my: 3 }}>
                  Entrar
                </InputButton>
              </Box>
            </Box>
          ) : sttPg.tipoAcesso === null ? (
            <Box
              sx={{ mt: 1, p: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
              <LockOutlinedIcon color='primary' sx={{ fontSize: 50, mb: 1 }} />
              <Typography variant='h6' fontWeight='bold' sx={{ mb: 1 }}>
                Centro esportivo privado
              </Typography>
              <Typography variant='body2' align='center' sx={{ mb: 3 }}>
                Você precisa solicitar acesso para agendar neste centro esportivo.
              </Typography>
              <InputText
                label='Forneça informações para sua aprovação'
                placeholder='Digite aqui'
                value={solAcesso}
                onChange={e => setSolAcesso(e.target.value)}
                sx={{ width: '500px' }}
              />

              <InputButton
                onClick={() => actionsCtxEmps.SolicitarAcessoCentroEsportivo(solAcesso)}
                sx={{ width: '20dvw', mt: 4 }}
                disabled={solAcesso === ''}
              >
                Enviar solicitação
              </InputButton>
            </Box>
          ) : sttPg.tipoAcesso === 'SOLICITADO' ? (
            <Box
              sx={{ mt: 1, p: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
              <LuClipboardPenLine size='50' color='#FF7043' />
              <Typography variant='h6' fontWeight='bold' sx={{ my: 1 }}>
                Acesso Solicitado
              </Typography>
              <Typography variant='body2' align='center'>
                Sua solicitação foi recebida pelo centro esportivo. Aguarde a aprovação.
              </Typography>
              <InputButton
                onClick={() => serverRouter('back')}
                sx={{ width: '20dvw', mt: 4 }}
                variant='text'
              >
                Voltar
              </InputButton>
            </Box>
          ) : sttPg.tipoAcesso === 'REVOGADO' || sttPg.tipoAcesso === 'RECUSADO' ? (
            <Box
              sx={{ mt: 1, p: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
              <BlockIcon color='error' sx={{ fontSize: 50 }} />
              <Typography variant='h6' fontWeight='bold' sx={{ mt: 1 }}>
                Você não foi autorizado(a)
              </Typography>
              <Typography variant='body2' align='center' sx={{ my: 2, width: '500px' }}>
                Sua solicitação foi recusada ou revogada pelo centro esportivo, você não poderá
                agendar aqui.
                {'\n\n'}Caso ache necessário, você pode entrar em contato com os responsáveis e
                solicitar sua autorização novamente.
              </Typography>
              <InputButton
                onClick={() => serverRouter('back')}
                variant='text'
                sx={{ width: '20dvw', mt: 4 }}
              >
                Voltar
              </InputButton>
            </Box>
          ) : sttPg.tipoAcesso === 'BLOQUEADO' ? (
            <Box
              sx={{ mt: 1, p: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
              <BlockIcon color='error' sx={{ fontSize: 50 }} />
              <Typography variant='h6' fontWeight='bold' sx={{ mt: 1 }}>
                Sem autorização
              </Typography>
              <Typography variant='body2' align='center' sx={{ my: 2, width: '500px' }}>
                Você não poderá agendar aqui por decisão única e exclusiva do próprio centro
                esportivo. Entre em contato com ele se você considera um engano
              </Typography>
              <InputButton
                onClick={() => serverRouter('back')}
                variant='text'
                sx={{ width: '20dvw', mt: 4 }}
              >
                Voltar
              </InputButton>
            </Box>
          ) : sttPg.tipoAcesso === 'DESATIVADO' ? (
            <Box
              sx={{ mt: 1, p: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
              <BlockIcon color='error' sx={{ fontSize: 50 }} />
              <Typography variant='h6' fontWeight='bold' sx={{ mt: 1 }}>
                Centro esportivo desativado
              </Typography>
              <Typography variant='body2' align='center' sx={{ my: 2 }}>
                Este centro esportivo foi desativado e não está disponível para agendamentos. Entre
                em contato com a central de atendimento.
              </Typography>
              <InputButton
                onClick={() => serverRouter('back')}
                variant='text'
                sx={{ width: '20dvw', mt: 4 }}
              >
                Voltar
              </InputButton>
            </Box>
          ) : (
            <Box
              sx={{ mt: 1, p: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
            >
              <img
                src={notAgend}
                alt='Erro inesperado'
                style={{ width: '250px', height: 'auto' }}
              />
              <Typography variant='h6' fontWeight='bold' sx={{ mt: 1 }}>
                Erro inesperado
              </Typography>
              <Typography variant='body2' align='center' sx={{ my: 2 }}>
                Houve um erro inesperado ao tentar solicitar acesso. Entre em contato com a central
                de atendimento.
              </Typography>
              <InputButton
                onClick={() => serverRouter('back')}
                variant='text'
                sx={{ width: '20dvw', mt: 4 }}
              >
                Voltar
              </InputButton>
            </Box>
          )}
        </Card>
      </Grid>
    </Grid>
  )
}
